import React from 'react';
import ReactDOM from 'react-dom';
import * as Reactstrap from 'reactstrap';

import { App } from './app/App';
import './index.css';
import '../src/i18n';

if (!HTMLElement.prototype.scrollTo) {
  HTMLElement.prototype.scrollTo = function (options: any) {
    this.scrollTop = options?.top || 0;
    this.scrollLeft = options?.left || 0;
  };
}

window.React = React;
window.ReactDOM = ReactDOM;
window.Reactstrap = Reactstrap;
window.isRenderedByContainer = true;

ReactDOM.render(<App />, document.getElementById('root'));
